/// <amd-module name="Pipeline/Analytics/Common/Components/PipelineAnalyticsPage" />
import { AnalyticsPage, IAnalyticsPageProps, IAnalyticsPageState } from "Analytics/Shared/Common/AnalyticsPage";
import { AnalyticsHubBreadCrumbService } from "Analytics/Shared/Common/Service/AnalyticsHubBreadCrumbService";
import { IAnalyticsDataService } from "Analytics/Shared/Common/Types";
import { getDefinitionIdFromUrl } from "Analytics/Shared/Utils/URLHelper";
import { getAnalyticsDataService } from "Pipeline/Analytics/Common/LoadAnalyticsDataService";
import * as Resources from "Pipeline/Analytics/Common/Resources";
import * as React from "react";
import { Components, VssComponent } from "VSS/Platform/Layout";

export interface IPipelineAnalyticsPageProps extends IAnalyticsPageProps {
    onSetPipelineName: (pipelineName: string) => void;
}

export class PipelineAnalyticsPage extends VssComponent<IPipelineAnalyticsPageProps, IAnalyticsPageState> {
    private _analyticsDataService: IAnalyticsDataService;

    public componentDidMount() {
        super.componentDidMount();
        this._getPipeline();
    }

    public render() {
        return <AnalyticsPage {...this.props} />;
    }

    private _getPipelineId(): number {
        return getDefinitionIdFromUrl(this.context.pageContext);
    }

    private async _getPipeline(): Promise<number> {
        // Load the Analytics Service
        this._analyticsDataService = await getAnalyticsDataService(this.context.pageContext);

        // Get the build definition and add breadcrumb.
        const definitionId = this._getPipelineId();
        if (definitionId > 0) {
            const definitionName = await this._analyticsDataService.fetchDefinitionName(definitionId);
            this.props.onSetPipelineName(definitionName);

            const breadCrumbService = this.context.pageContext.getService<AnalyticsHubBreadCrumbService>("analytics-hub-breadcrumb-service");
            breadCrumbService.addDefinition(definitionId);
        } else {
            this.props.onError(Resources.NotValidPipelineDefinition);
        }

        return definitionId;
    }
}

Components.add("pipelineAnalyticsPage", PipelineAnalyticsPage);
